export default "__VITE_ASSET__DDX_08Yu__"